var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
    stroke: "url(#paint0_linear_4301_21850)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 8L8 12",
    stroke: "url(#paint1_linear_4301_21850)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 8L12 12",
    stroke: "url(#paint2_linear_4301_21850)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4301_21850",
    x1: 18,
    y1: 2,
    x2: -0.572803,
    y2: 5.63193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF1414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4301_21850",
    x1: 12,
    y1: 8,
    x2: 7.3568,
    y2: 8.90798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF1414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4301_21850",
    x1: 12,
    y1: 8,
    x2: 7.3568,
    y2: 8.90798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF1414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.ef463fce737f141d2fc4995bbdda73ac.svg";
export { ForwardRef as ReactComponent };